var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNose = function SvgNose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.838 5.984h1.5v3.75q0 .725-.513 1.238a1.69 1.69 0 0 1-1.237.512h-.75q-1.05 0-1.775.725a2.42 2.42 0 0 0-.725 1.775q0 1 .725 1.675t1.775.8v1.525q-1.65-.125-2.825-1.25t-1.175-2.75q0-1.65 1.175-2.825t2.825-1.175h1zm6.5 0h1.5v4h1q1.65 0 2.825 1.175t1.175 2.825q0 1.626-1.175 2.75c-1.175 1.124-1.725 1.167-2.825 1.25V16.46q1.05-.125 1.775-.8t.725-1.675q0-1.05-.725-1.775t-1.775-.725h-.75q-.725 0-1.238-.512a1.69 1.69 0 0 1-.512-1.238zm-2.775 13q-1.025 0-1.838-.6-.811-.6-1.137-1.55a1.2 1.2 0 0 0-.463-.612 1.25 1.25 0 0 0-.737-.238h-.55v-1.5h.55q.875 0 1.6.513a2.6 2.6 0 0 1 1 1.362q.175.5.612.813.438.312.963.312h.55q.524 0 .962-.312.438-.314.613-.813a2.6 2.6 0 0 1 1-1.362 2.7 2.7 0 0 1 1.6-.513h.55v1.5h-.55q-.425 0-.75.238a1.22 1.22 0 0 0-.45.612 3.16 3.16 0 0 1-1.138 1.55q-.812.6-1.837.6z"
  }))));
};
export default SvgNose;